import { RETROFIT_TARGET_STANDARD_LIST } from "./retrofit-target-standard";
const BAND_BY_TARGET_STANDARD = Object.fromEntries(RETROFIT_TARGET_STANDARD_LIST.map((standard) => [standard.key, standard.band]));
export const resolveTargetUsefulHeatOutput = ({ profile, targetStandard, }) => profile.usefulHeatOutputKwhPerSquareMetre[BAND_BY_TARGET_STANDARD[targetStandard]];
